import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DodoProduct, Discount } from "./plan.models";
import { DodoCartProduct } from "app/shopping-cart/dodo-cart-product.class";
import { LocalStorageService } from "../../@dodo/local-storage";

@Injectable({
	providedIn: "root"
})
export class PlanService {
	productSelected$: BehaviorSubject<DodoProduct>;
	fullSqResponse$: BehaviorSubject<any>;

	private __products: { [key: string]: DodoProduct } = {};
	private __discount: Discount;

	private __productDiscountMap: { [product: string]: Discount } = {
		electricity: <Discount>{
			amount: 5,
			type: "dollar",
			term: "full-term"
		},
		gas: <Discount>{
			amount: 5,
			type: "dollar",
			term: "full-term"
		},
		mobile: <Discount>{
			amount: 5,
			type: "dollar",
			term: "full-term"
		}
	};

	constructor(private __localStorageService: LocalStorageService) {
		this.productSelected$ = new BehaviorSubject(undefined);
		this.fullSqResponse$ = new BehaviorSubject(undefined);
	}

	public minimumCost = "";

	productSelected(product: DodoProduct) {
		const service = DodoCartProduct.ToService(product.type);

		this.__products[service] = product;
		this.__products[service].subTextFooter = this.__products[
			service
		].subText;

		if (service !== "energy") {
			this.__products[service].monthlyCostFooter = this.__products[
				service
			].monthlyCost;
		}

		if (product.monthlyCost) {
			if (service in this.__productDiscountMap) {
				this.__discount = this.__productDiscountMap[service];
			}
		} else {
			this.__discount = undefined;
		}

		if (service === "mobile") {
			product.discount =
				product.discount && product.discount.amount
					? product.discount
					: undefined;
			this.productSelected$.next(product);
		} else {
			this.productSelected$.next(product);
			if ("internet" in this.__products) {
				this.__products["internet"].discount = this.__discount;
				this.productSelected$.next(this.__products["internet"]);
			}
		}
	}


	productSelectionValid(product: DodoProduct, validity: boolean) {
		const service = DodoCartProduct.ToService(product.type);
		this.__products[service].selectionValid = validity;
	}

	updateFullSqResponse(value: any): void {
		this.fullSqResponse$.next(value);
	}

	public isDealerDataView(): boolean {
		const dealer = this.__localStorageService.getFromLocalStorage("dealer");
		const dealerEnergyView = this.__localStorageService.getFromLocalStorage(
			"dealerEnergyView"
		);

		return !!dealer && !!dealer.id ? dealerEnergyView : false;
	}
}
